export const IMAGES_PATH = 'IMAGES_PATH';
